import React from 'react';
import { FlameIcon, TimerIcon, TriangleAlertIcon } from 'lucide-react';
import { Container } from './Container';
import { CountdownUnits } from './CountdownUnits';
import { salesProof } from '../data/salesProof';
import { usePricing } from '../hooks/usePricing';
import { formatARS } from '../utils/currency';

/**
 * Contador hacia la fecha real de cierre del lanzamiento + barra de cupos reales.
 * Se oculta solo mientras esos datos no estén cargados en data/salesProof.ts.
 */
export function UrgencyBlock() {
  const {
    countdown,
    launchActive
  } = usePricing();
  const {
    seats,
    priceAfterLaunch
  } = salesProof;
  const hasSeats = seats.total > 0;
  const seatsPct = hasSeats ? Math.min(100, Math.round(seats.taken / seats.total * 100)) : 0;
  if (!countdown.configured && !hasSeats) return null;
  return <section aria-label="Precio de lanzamiento" className="bg-white pb-16 sm:pb-20" data-id="element-460" data-mp="t84ju82745ys">
      <Container data-id="element-461" data-mp="p7ax3i0hox7h">
        <div className="mx-auto max-w-3xl rounded-3xl border-2 border-pink/50 bg-pink-light/60 px-5 py-8 text-center sm:px-10" data-id="element-462" data-mp="p8vowzvf621n">
          {countdown.ended ? <p className="font-heading text-xl font-extrabold text-navy sm:text-2xl" data-id="element-463" data-mp="19wgs9blq98jh">El precio de lanzamiento terminó.</p> : <>
              {launchActive && <>
                  <p className="flex items-center justify-center gap-2 font-display text-sm font-extrabold uppercase tracking-[0.1em] text-navy" data-id="element-464" data-mp="zy0zz5ayrt8e">
                    <TimerIcon aria-hidden="true" className="h-5 w-5 text-pink" data-id="element-465" data-mp="1nowuia6t12jc" />
                    Precio de lanzamiento — cierra en:
                  </p>
                  <div className="mt-4" data-id="element-466" data-mp="1ewml2v3qh135">
                    <CountdownUnits countdown={countdown} data-id="element-467" data-mp="1evl09ywx1088" />
                  </div>
                  {priceAfterLaunch > 0 && <p className="mt-4 flex items-center justify-center gap-1.5 text-base font-semibold text-navy" data-id="element-468" data-mp="26n97k70u6wk7">
                      <TriangleAlertIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-pink" data-id="element-469" data-mp="2be90l16u4uhf" />
                      Después sube a {formatARS(priceAfterLaunch)}.
                    </p>}
                </>}

              {hasSeats && <div className={launchActive ? 'mx-auto mt-7 max-w-md' : 'mx-auto max-w-md'} data-id="element-470" data-mp="2c91ap6qszbv4">
                  <p className="flex items-center justify-center gap-1.5 text-sm font-bold text-navy" data-id="element-471" data-mp="279x50q337w9j">
                    <FlameIcon aria-hidden="true" className="h-4 w-4 text-pink" data-id="element-472" data-mp="22atyt2bdfjzz" />
                    Cupos al precio de lanzamiento
                  </p>
                  <div className="mt-2 h-3 overflow-hidden rounded-full bg-white" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={seatsPct} aria-label="Cupos tomados" data-id="element-473" data-mp="1xikcrxddn42z">
                    <div className="h-full rounded-full bg-pink" style={{
                width: `${seatsPct}%`
              }} data-id="element-474" data-mp="1jm6syhldeqlc" />
                  </div>
                  <p className="mt-2 text-sm text-navy-soft" data-id="element-475" data-mp="14hksgs01gn8y">{seatsPct}% de los cupos ya tomados</p>
                </div>}
            </>}
        </div>
      </Container>
    </section>;
}